import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import emiImg from "../assets/emi.png"; 

export default function EMICalculator() {
  const [loanAmount, setLoanAmount] = useState(250000);
  const [interestRate, setInterestRate] = useState(11);
  const [loanDuration, setLoanDuration] = useState(8);

  const monthlyInterest = interestRate / 12 / 100;
  const months = loanDuration * 12;
  const emi =
    (loanAmount * monthlyInterest * Math.pow(1 + monthlyInterest, months)) /
    (Math.pow(1 + monthlyInterest, months) - 1);

  const totalPayment = emi * months;
  const totalInterest = totalPayment - loanAmount;

  return (
  
    <div style={styles.pageContainer}>
          <div className="row d-flex justify-content-center">
          <div className="col-10">
      <div className=" py-5">
        <h2 className="text-center fw-bold mb-3">EMI Calculator</h2>

        <div className="row align-items-center">
          {/* Left Side - Form */}
          <div className="col-md-6">
            <div style={styles.formBox} className="me-5 pt-5">
              {/* Loan Type */}
              <div className="mb-4">
                <label className="form-label fw-semibold">Loan Type</label>
                <select className="form-select">
                  <option>Personal Loan</option>
                  <option>Home Loan</option>
                  <option>Car Loan</option>
                  <option>Education Loan</option>
                </select>
              </div>

              {/* Loan Amount */}
              <div className="mb-4">
                <label className="form-label fw-semibold">Loan Amount</label>
                <input
                  type="text"
                  value={`₹${loanAmount.toLocaleString()}`}
                  className="form-control mb-2"
                  readOnly
                />
                <input
                  type="range"
                  min="50000"
                  max="500000"
                  step="10000"
                  value={loanAmount}
                  onChange={(e) => setLoanAmount(Number(e.target.value))}
                  className="w-100"
                />
                <div className="d-flex justify-content-between small text-muted mt-1">
                  <span>₹50,000</span>
                  <span>₹5,00,000</span>
                </div>
              </div>

              {/* Loan Duration */}
              <div className="mb-4">
                <label className="form-label fw-semibold">Loan Duration</label>
                <div className="d-flex align-items-center gap-2">
                  <input
                    type="number"
                    className="form-control"
                    style={{ width: "80px" }}
                    value={loanDuration}
                    onChange={(e) => setLoanDuration(Number(e.target.value))}
                  />
                  <button className="btn btn-light border">Yr</button>
                  <button className="btn btn-primary text-white">Mo</button>
                </div>
              </div>

              {/* Rate of Interest */}
              <div className="mb-4">
                <label className="form-label fw-semibold">Rate of Interest</label>
                <input
                  type="text"
                  value={`${interestRate}%`}
                  className="form-control mb-2"
                  readOnly
                />
                <input
                  type="range"
                  min="5"
                  max="20"
                  step="0.5"
                  value={interestRate}
                  onChange={(e) => setInterestRate(Number(e.target.value))}
                  className="w-100"
                />
                <div className="d-flex justify-content-between small text-muted mt-1">
                  <span>5% p.a</span>
                  <span>20% p.a</span>
                </div>
              </div>

              <button className="btn text-white fw-semibold" style={styles.applyBtn}>
                Apply Now →
              </button>
            </div>
          </div>

       {/* Right Side - EMI Result */}
<div className="col-md-6 text-center d-flex justify-content-center align-items-center mt-md-0 mt-3">
  <img
    src={emiImg}
    alt="EMI Calculator"
    className="img-fluid"
    style={{
      maxWidth: "100%",
      height: "auto",
      borderRadius: "20px",
      objectFit: "cover",
    }}
  />
</div>

        </div>
      </div>
      </div></div>
    </div>
   
  );
}

const styles = {
  pageContainer: {
    backgroundColor: "#fce8ba",
    minHeight: "100vh",
  overflowX: "hidden",
  },
  formBox: {
    borderRadius: "16px",
   
    
  },
  resultCard: {
    backgroundColor: "#fff",
    borderRadius: "20px",
    padding: "30px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    display: "inline-block",
  },
  pieChart: {
    width: "100px",
    height: "100px",
    margin: "0 auto",
    position: "relative",
  },
  pie: {
    width: "100%",
    height: "100%",
    borderRadius: "50%",
  },
  emiBox: {
    backgroundColor: "#f17c58",
    color: "#fff",
    padding: "15px",
    borderRadius: "12px",
    marginTop: "20px",
  },
  applyBtn: {
    backgroundColor: "#f17c58",
    border: "none",
    padding: "10px 20px",
    borderRadius: "8px",
  },
};
